import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import LogisticsDashboardMobile from "../mobile/logistics/LogisticsDashboardMobile";
import LogisticsDashboard from "./dashboard/LogisticsDashboard";

export default function ResponsiveLogisticsDashboard(props) {
  return useIsMobile() ? <LogisticsDashboardMobile {...props} /> : <LogisticsDashboard {...props} />;
}
